import React from 'react';
import SeismicContentPicker from 'components/shared/SeismicContentPicker';

const ContentLesson = ({ documentPicked }) => {
  return (
    <div className="LessonGenerateModal--full-width">
      <SeismicContentPicker
        repositories={['doccenter', 'workspace', 'library']}
        pickerSettings={{
          formatFilter: {
            filterType: 'whitelist',
            values: [
              'PPTX',
              'PPT',
              'GSLIDES',
              'KEY',
              'DOCX',
              'DOC',
              'GDOC',
              'PDF',
              'STATIC_FOLDER',
            ],
          },
          assetTypeFilter: {
            filterType: 'whitelist',
            values: ['File', 'Folder'],
          },
        }}
        documentPicked={documentPicked}
      />
    </div>
  );
};

export default ContentLesson;
